import React from 'react';

const TeacherPastLessonsModal = ({
  isPastLessonsModalOpen,
  closePastLessonsModal,
  selectedTeacherLessons,
  selectedTeacherInfo,
  loadingLessons,
  lessonGroups
}) => {
  if (!isPastLessonsModalOpen) return null;

  const totalDersUcret = selectedTeacherLessons.reduce((sum, l) => sum + (parseFloat(l.ders_ucret) || 0), 0);
  const totalSirketPayi = selectedTeacherLessons.reduce((sum, l) => sum + (parseFloat(l.sirket_payi) || 0), 0);
  const totalDanisman1 = selectedTeacherLessons.reduce((sum, l) => sum + (parseFloat(l.danisman1) || 0), 0);
  const totalDanisman2 = selectedTeacherLessons.reduce((sum, l) => sum + (parseFloat(l.danisman2) || 0), 0);
  const totalDanisman3 = selectedTeacherLessons.reduce((sum, l) => sum + (parseFloat(l.danisman3) || 0), 0);
  const teacherEarnings = totalDersUcret - totalSirketPayi;
  const totalGeneral = totalDersUcret + totalSirketPayi + totalDanisman1 + totalDanisman2 + totalDanisman3;

  const thClass = "text-left px-3 py-2 text-xs font-medium text-gray-500 whitespace-nowrap";
  const tdClass = "px-3 py-2 text-sm text-gray-700";
  const money = (v) => `₺${parseFloat(v || 0).toFixed(2)}`;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-3 sm:p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-7xl max-h-[95vh] flex flex-col overflow-hidden border border-gray-200">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-3 border-b border-gray-200">
          <div>
            <h3 className="text-base font-semibold text-gray-900">Geçmiş Dersler</h3>
            <p className="text-xs text-gray-500 mt-0.5">
              {selectedTeacherInfo?.name} • {selectedTeacherLessons.length} ders
            </p>
          </div>
          <button
            onClick={closePastLessonsModal}
            className="p-1.5 rounded-md text-gray-400 hover:text-gray-900 hover:bg-gray-100 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-5">
          {loadingLessons ? (
            <div className="flex items-center justify-center h-64">
              <div className="animate-spin rounded-full h-8 w-8 border-2 border-gray-300 border-t-gray-900"></div>
            </div>
          ) : selectedTeacherLessons.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-64 text-gray-400">
              <svg className="w-10 h-10 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="text-sm">Ders kaydı bulunamadı</p>
            </div>
          ) : (
            <div className="rounded-md border border-gray-200 overflow-x-auto">
              <table className="w-full min-w-max">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className={thClass}>Öğrenci</th>
                    <th className={thClass}>Ders Grubu</th>
                    <th className={thClass}>Konu</th>
                    <th className={thClass}>Süre</th>
                    <th className={thClass}>Tarih</th>
                    <th className={thClass}>Ücret</th>
                    <th className={thClass}>Şirket</th>
                    <th className={thClass}>Dan. 1</th>
                    <th className={thClass}>Dan. 2</th>
                    <th className={thClass}>Dan. 3</th>
                    <th className={thClass}>Toplam</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {selectedTeacherLessons.map((lesson) => (
                    <tr key={lesson.id} className="hover:bg-gray-50">
                      <td className={tdClass}>
                        <div className="font-medium text-gray-900">{lesson.ogrenci_name || '—'}</div>
                        <div className="text-xs text-gray-500">{lesson.parent_phone || '—'}</div>
                      </td>
                      <td className={tdClass}>
                        <span className="text-xs text-gray-600">
                          {lessonGroups.find(g => g.id == lesson.ders_grubu_id)?.ders_adi || '—'}
                        </span>
                      </td>
                      <td className={`${tdClass} text-gray-600`}>{lesson.ders_konusu || '—'}</td>
                      <td className={`${tdClass} text-gray-600`}>{lesson.ders_sure ? `${lesson.ders_sure} dk` : '—'}</td>
                      <td className={`${tdClass} text-gray-600 whitespace-nowrap`}>
                        {lesson.baslangic_tarihi ? new Date(lesson.baslangic_tarihi).toLocaleDateString('tr-TR') : '—'}
                      </td>
                      <td className={tdClass}>{money(lesson.ders_ucret)}</td>
                      <td className={`${tdClass} text-gray-500`}>{money(lesson.sirket_payi)}</td>
                      <td className={`${tdClass} text-gray-500`}>{lesson.danisman1 > 0 ? money(lesson.danisman1) : '—'}</td>
                      <td className={`${tdClass} text-gray-500`}>{lesson.danisman2 > 0 ? money(lesson.danisman2) : '—'}</td>
                      <td className={`${tdClass} text-gray-500`}>{lesson.danisman3 > 0 ? money(lesson.danisman3) : '—'}</td>
                      <td className={`${tdClass} font-medium text-gray-900`}>
                        {money(
                          parseFloat(lesson.ders_ucret || 0) +
                          parseFloat(lesson.sirket_payi || 0) +
                          parseFloat(lesson.danisman1 || 0) +
                          parseFloat(lesson.danisman2 || 0) +
                          parseFloat(lesson.danisman3 || 0)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="bg-gray-50 border-t border-gray-200">
                  <tr>
                    <td colSpan="5" className={`${tdClass} text-right font-medium text-gray-500`}>Toplam</td>
                    <td className={`${tdClass} font-semibold text-gray-900`}>{money(totalDersUcret)}</td>
                    <td className={`${tdClass} font-semibold text-gray-900`}>{money(totalSirketPayi)}</td>
                    <td className={`${tdClass} font-semibold text-gray-900`}>{money(totalDanisman1)}</td>
                    <td className={`${tdClass} font-semibold text-gray-900`}>{money(totalDanisman2)}</td>
                    <td className={`${tdClass} font-semibold text-gray-900`}>{money(totalDanisman3)}</td>
                    <td className={`${tdClass} font-semibold text-gray-900`}>{money(totalGeneral)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 px-5 py-3 bg-gray-50/50 flex flex-wrap justify-between items-center gap-3">
          <div className="flex gap-5 text-xs text-gray-600">
            <span>
              Öğretmen kazancı: <span className="font-semibold text-gray-900">{money(teacherEarnings)}</span>
            </span>
            <span>
              Genel toplam: <span className="font-semibold text-gray-900">{money(totalGeneral)}</span>
            </span>
          </div>
          <button
            onClick={closePastLessonsModal}
            className="px-4 py-1.5 text-sm text-gray-700 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherPastLessonsModal;
